import __request__ from "routing/request";
export function create(JSONbody) {
  return __request__("POST", "/views/export", JSONbody, {}, {
    "Accept": []
  });
}
export function createForSearch(searchId, Optionaloverrides) {
  return __request__("POST", `/views/export/${searchId}`, Optionaloverrides, {}, {
    "Accept": []
  });
}
export function createForSearchType(searchId, searchTypeId, Optionaloverrides) {
  return __request__("POST", `/views/export/${searchId}/${searchTypeId}`, Optionaloverrides, {}, {
    "Accept": []
  });
}
